// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__uppfz","info":"PatientInfo_info__2wUaR"};